<template functional>
	<span>
		<svg
			v-if="props.filled"
			xmlns="http://www.w3.org/2000/svg"
			:width="props.size"
			:height="props.size"
			viewBox="0 0 130 130"
		><path :style="`fill: ${props.color}`" d="M65,11C40.18692,11,20,30.54909,20,54.578,20,72.4931,42.80848,100.271,56.40441,115.23465a11.69374,11.69374,0,0,0,17.19118,0C87.19146,100.271,110,72.4931,110,54.578,110,30.54909,89.81308,11,65,11ZM80.03056,54.55156a15.00057,15.00057,0,1,1-15-14.86957A14.93521,14.93521,0,0,1,80.03056,54.55156Z" /></svg>
		<svg
			v-else
			xmlns="http://www.w3.org/2000/svg"
			:width="props.size"
			:height="props.size"
			viewBox="0 0 130 130"
		><path :style="`fill: ${props.color}`" d="M65,18.93043c20.40186,0,37,15.99144,37,35.6475,0,10.98627-12.84058,31.67757-34.34888,55.34931a3.64782,3.64782,0,0,1-5.30249,0C40.84058,86.25574,28,65.56445,28,54.57793c0-19.65606,16.59814-35.6475,37-35.6475M65,11C40.18677,11,20,30.54909,20,54.57793c0,17.91512,22.80835,45.69317,36.4043,60.65676a11.6938,11.6938,0,0,0,17.19116,0C87.19141,100.2711,110,72.49305,110,54.57793,110,30.54909,89.813,11,65,11Zm.03052,28.682a14.87013,14.87013,0,1,1-15,14.86956,14.93525,14.93525,0,0,1,15-14.86956m0-7.93043a22.80086,22.80086,0,1,0,23,22.8,22.92666,22.92666,0,0,0-23-22.8Z" /></svg>
	</span>
</template>

<script>
export default {
	name: 'MapPinIcon',
	props: {
		color: {
			type: String,
			default: '#2487C4'
		},
		filled: Boolean,
		size: {
			type: Number,
			default: 25
		}
	}
};
</script>